import React from 'react';
import * as firebase from 'firebase';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import ImageUploader from '../image-uploader/image-uploader';
import MediaUploader from '../media-uploader/media-uploader';
import HallSelector from './hall-selector';
import './booth-metadata.css';

/** @class BoothMetadata
 * A component for editing a booth's metadata properties
 * (name, published status, and booth icon)
 */
export default class BoothMetadata extends ReactFireComponent {
  /** @constructor
    * Constructs a new instance of BoothMetadata
    */
  constructor(props) {
    super(props);
    this.state = {
      booth: {
        name: '',
        published: false,
        halls: [],
        welcomeVideo: '',
        icon: '',
        interior: ''
      }
    }
    this.firebaseRef = firebase.database().ref(this.props.dataURL);
    this.hallRef = firebase.database().ref(this.props.dataURL.split('/').slice(0,3).join('/').concat('/halls'));
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleImageUpload = this.handleImageUpload.bind(this);
  }
  /** @function componentWillMount
    * Connects the component to its corresponding
    * data in the Firebase realtime database
    */
  componentWillMount() {
    this.bindAsObject(this.props.dataURL, 'booth');
  }
  /** @function componentWillUnmount
    * Disconnects the component from the
    * Firebase realtime database
    */
  componentWillUnmount() {
    this.unbind('booth');
  }
  /** @function handleChange
    * Handles updates to input fields by updating the
    * component's state
    * @param {ChangeEvent} - the event that triggered
    * this handler
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    var booth = this.state.booth;
    booth[name] = value;
    this.setState({
      booth: booth
    });
  }
  /** @function handleBlur
    * Saves changes to the component's state to the
    * firebase entry.
    * @param {ChangeEvent} event - the event that
    * triggered this handler
    */
  handleBlur() {
    this.firebaseRef.set(this.state.booth);
  }
  /** @function handleImageUpload
    * Handles updates to images by updating the
    * component's state
    * @param {String} name - the name of the image property
    * @param {Url} url - the url for the new image
    */
  handleImageUpload(name, url) {
    var booth = this.state.booth;
    booth[name] = url;
    this.setState({booth: booth}, () => this.handleBlur());
  }
  /** @function render
    * Renders the component
    */
  render() {
    return (
      <div className="metadata-panel">
        <div className="metadata-column">
          <div>
            <label htmlFor="name">Name</label><br/>
            <input type="text" name="name"
              value={this.state.booth.name}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              />
          </div>
          <div>
            <label htmlFor="published">
              <input type="checkbox" name="published"
                checked={this.state.booth.published || false}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                />
              Published
            </label>
          </div>
          <HallSelector expoID={this.props.expoID}
            boothID={this.props.boothID}
            {...this.state.booth}
            onSelect={this.handleHallSelect}
            />
          <div>
            <MediaUploader
              name="Welcome Video"
              value={this.state.booth.welcomeVideo}
              dataURL={this.props.dataURL + '/welcomeVideo'}
              onUpload={(url)=>this.handleImageUpload('welcomeVideo', url)}
              />
          </div>
        </div>
        <div className="metadata-column">
          <div className="metadata-icon">
            <ImageUploader
              name="Booth Icon"
              value={this.state.booth.icon}
              dataURL={this.props.dataURL + '/icon'}
              onUpload={(url)=>this.handleImageUpload('icon', url)}
              />
          </div>
          <div>
            <ImageUploader
              name="Booth Interior"
              value={this.state.booth.interior}
              dataURL={this.props.dataURL + '/interior'}
              onUpload={(url)=>this.handleImageUpload('interior', url)}
              />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/booth-editor/booth-metadata.js